// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rko1y44{border-radius:4px}._1bsb1wug{width:auto}\n._c71l1ymo{max-height:6.5rem}", ""]);
// Exports
module.exports = exports;
